interface ValidationResult {
    isValid: boolean;
    errors: {
        type: 'missing_field' | 'invalid_file_type' | 'other';
        field?: string;
        message: string;
    }[];
}

type ValidationError = ValidationResult['errors'][0];

export const validateToolCall = (finishedToolCall: any): ValidationResult => {
    const errors: ValidationError[] = [];
    const REQUIRED_TOOL_FIELDS: any = {
        editFile: ['filePath', 'startLine', 'endLine'],
        createFile: ['filePath'],
        deleteFile: ['filePath'],
        moveFile: ['filePath', 'newFilePath'],
        runTerminalCommand: ['command'],
        deepResearch: ['task']
    };

    if (!(finishedToolCall.name in REQUIRED_TOOL_FIELDS)) {
        return { isValid: true, errors: [] };
    }

    // Check for required fields
    for (const field of REQUIRED_TOOL_FIELDS[finishedToolCall.name]) {
        if (!finishedToolCall.args[field]) {
            errors.push({
                type: 'missing_field' as const,
                field,
                message: `Missing required field: ${field}`
            });
        }
    }

    // Check for invalid media file extensions
    const INVALID_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.mp4', '.mp3', '.wav', '.gif', '.webp', '.mov', '.avi'];
    const filePathFields = ['filePath', 'newFilePath'];

    for (const field of filePathFields) {
        if (finishedToolCall.args[field]) {
            const filePath = finishedToolCall.args[field].toLowerCase();
            const fileExt = '.' + filePath.split('.').pop();

            if (INVALID_EXTENSIONS.includes(fileExt)) {
                errors.push({
                    type: 'invalid_file_type' as const,
                    field,
                    message: `${field} cannot be a media file (${fileExt})`
                });
            }
        }
    }

    return {
        isValid: errors.length === 0,
        errors
    };
}
